"use client";

import Session from "@lib/session";
import { useEffect } from "react";

export default function DefaultServiceArea({
  defaultServiceArea,
}: {
  defaultServiceArea?: number;
}) {
  useEffect(() => {
    if (!defaultServiceArea) return;
    if (!Session.getConfig().serviceArea) Session.updateConfig({ serviceArea: defaultServiceArea });
  }, [defaultServiceArea]);

  return null;
}
